export function raise(message) {
    throw new Error(message);
}
//# sourceMappingURL=raise.js.map